import React, { Component, Fragment } from 'react';
import get from 'lodash/get';
import Loading from 'components/Loading/Loading';
import { connect } from 'react-redux';

import Footer from '../Footer';

class SkypeNameSelect extends Component {
  handleChange = (event) => {
    this.props.onChange(event.target.value);
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.onNext();
  }

  render() {
    const {
      error, onBack, username, updateStatus
    } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <div className="mx-auto onboard-step onboard-step--3">
          <p className="step__number" data-qa-id="step3-title">Step 3/3</p>
          <h4 className="mb-2">Share your Skype username</h4>
          <p className="step__description mb-4">
            This is how your teacher will be able to connect with you at the time of your lesson.
          </p>
          <div className="input-group input-group-lg mx-auto">
            <input
              value={username}
              type="text"
              className="form-control"
              placeholder="Johnsmith123"
              onChange={this.handleChange}
              onSubmit={this.handleSubmit}
            />
          </div>
          {updateStatus === 'FAIL' && (
            <p className="my-2 error">{get(error, 'message') || 'Something went wrong'}</p>
          )}
          <div className="my-3">
            {updateStatus === 'LOADING' ? (
              <Loading className="btn-next" size="small" />
            ) : (
              <Fragment>
                <button
                  type="submit"
                  className="btn btn-primary btn-lg btn-cursor btn-next my-3 px-5"
                  disabled={username.length === 0}
                >
                  Next
                </button>
                <p className="press-enter">OR PRESS ENTER</p>
              </Fragment>
            )}
          </div>
        </div>
        <Footer onBack={onBack} />
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    error: state.user.error,
    updateStatus: state.user.updateStatus
  };
}

export default connect(mapStateToProps)(SkypeNameSelect);



// WEBPACK FOOTER //
// ./src/pages/student/OnBoard/SkypeNameSelect/index.js